import AuthSecondaryLayout from './AuthSecondaryLayout'

export default AuthSecondaryLayout
